import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { authService } from "@/services/auth-service";
import { LogOut, List, Settings } from "lucide-react";

const DashboardHeader = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  
  const handleLogout = () => {
    // Use the proper auth service logout method
    authService.logout();
    
    toast({
      title: "Logged out",
      description: "You have been successfully logged out of LevAI",
    });
    navigate("/");
  };

  return (
    <div className="relative flex justify-center items-center mb-8">
      <h1 className="text-3xl font-bold text-brand-700 text-center">LevAI</h1>
      <div className="flex gap-2 absolute right-0">
        <Button 
          variant="outline" 
          className="flex items-center gap-2"
          onClick={() => navigate("/entries")}
        >
          <List size={16} />
          <span>View Entries</span>
        </Button>
        <Button 
          variant="outline" 
          className="flex items-center gap-2"
          onClick={() => navigate("/config")}
        >
          <Settings size={16} />
          <span>Config</span>
        </Button>
        <Button 
          variant="outline" 
          className="flex items-center gap-2"
          onClick={handleLogout}
        >
          <LogOut size={16} />
          <span>Logout</span>
        </Button>
      </div>
    </div>
  );
};

export default DashboardHeader;
